import React, { useEffect, useState } from "react";
import { CheckCircle, X } from "lucide-react";

const TransactionPopup = ({ message = "Transaction complete", duration = 10000, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show popup immediately
    setIsVisible(true);

    // Hide popup after duration
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Call onClose after animation completes
      setTimeout(() => {
        if (onClose) onClose();
      }, 300);
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  };

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-300 ease-in-out ${
        isVisible 
          ? "translate-y-0 opacity-100" 
          : "translate-y-full opacity-0"
      }`}
    >
      <div className="bg-blue-600/70 backdrop-blur-sm text-white px-8 py-6 rounded-lg shadow-lg flex items-center space-x-4 min-w-80 relative">
        <CheckCircle className="w-8 h-8 text-white flex-shrink-0" />
        <div>
          <p className="font-semibold text-white text-lg">{message}</p>
          <p className="text-blue-100 text-base">Your payment has been processed successfully</p>
        </div>
        
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-2 right-2 p-1 rounded-full hover:bg-white/20 transition-colors duration-200"
          aria-label="Close popup"
        >
          <X className="w-5 h-5 text-white" />
        </button>
      </div>
    </div>
  );
};

export default TransactionPopup; 